/*
 * © Copyright 2014 – 2023,2025 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import PropTypes from 'prop-types';
import React from 'react';
import t from '../../../i18n/locale-keys';

export default function TestAuthenticatorButton({onClick, show, disabled}) {
    if (show) {
        return (
            <button className="ias-button" id="Test_Button" type="button" onClick={onClick} disabled={disabled} >
                {t.buttonTestMethod()}
            </button>
        );
    }

    return null;
}

TestAuthenticatorButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired
};
